import { useMemo } from "react"
import { useParams } from "react-router-dom"
import { useProjectsContext } from "../contexts/ProjectsProvider"
import useGetFormStatuses from "../hooks/useGetFormStatus"
import useGetProjects from "../hooks/useGetProjects"
import useGetProjectTemplate from "../hooks/useGetProjectTemplate"
import IAuditFilters from "../interfaces/IAuditFilters"
import AuditLogs from "./admin/auditlogs"

const Audit = () => {
  const params = useParams<{ _id?: string }>()
  const _id = params._id ?? ""
  useGetProjects({ projectId: _id, withForms: true })
  useGetProjectTemplate({ projectId: _id })
  useGetFormStatuses(_id)

  const { currentProject } = useProjectsContext()

  // Use useMemo to recompute when currentProject changes
  const auditLogFilters: IAuditFilters = useMemo(() => ({
    elementsIds: currentProject
      ? [
          currentProject._id,
          ...(currentProject.forms || []).map((ft) => ft._id),
        ]
      : [],
  }), [currentProject?._id, currentProject?.forms])

  return <AuditLogs predefinedFilters={auditLogFilters} />
}

export default Audit
